import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import StarIcon from '../../Icons/Star';

import './style.scss';
import './mobile.scss';

import constants from '../../../constants';
import Button from '../../Button';
import {reviewsCountFrom} from '../../../tools/formatters';

const ReviewsStats = (props) => {
  const {stats, average} = props;
  return (
    <>
      <div className='reviews-stats'>
        <div className='reviews-stats__row'>
          <Button className='lg w-full' to={constants.ROUTES.NEW_REVIEW_PATH}>Оставить отзыв</Button>
        </div>
        <div className='reviews-stats__row'>
          <div className='reviews-stats__average'><StarIcon width={36} height={36} /> {average || 0}</div>
          средняя оценка покупателей
        </div>
        <div className='reviews-stats__row'>
          <div className='reviews-stats__stars'>
            {
              Object.keys(stats || {}).map((key) => {
                const count = stats[key];
                return count > 0 ? (
                  <div className='reviews-stats__stars-row' key={key}>
                    <div className='reviews-stats__stars-row-stars'>
                      {Array.from(Array(Number(key))).map((x,i) => <StarIcon key={i} width={24} height={24} />)}
                    </div>
                    <div className='reviews-stats__stars-row-title'>{count} {reviewsCountFrom(count)}</div>
                  </div>
                ) : null
              })
            }
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({applicationState}) => {
    return {
      applicationState
    };
  },

  withConnect = connect(
    mapStateToProps
  );

export default compose(withConnect)(ReviewsStats);

